export default __webpack_public_path__ + "static/media/down-arrow-black.afc76f20.svg";